import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader, Typography } from '@rappi/rests-commons-front';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../commons/header/Header';
import { Tabs } from '../../commons/tabs/tabs';
import { MenuGeneratorTable } from '../../components/menu-generator-table/menu-generator-table';
import { Top10Table } from '../../components/top-10-table/top-10-table';
import { useGlobal } from '../../context/global/global.context';
import { useCountriesAllowed } from '../../hooks/use-countries-allowed';
import { Container, TabContent, TabsContainer } from './styles';
import { Tab } from './types';
export const MenuGenerator = () => {
    const { t } = useTranslation();
    const { state } = useGlobal();
    const { country } = state;
    const { data: countriesAllowed, isLoading } = useCountriesAllowed();
    const isCountryAllowed = country ? countriesAllowed === null || countriesAllowed === void 0 ? void 0 : countriesAllowed[country] : false;
    const [activeTab, setActiveTab] = useState(Tab.MenuGenerator);
    const countryName = country ? t(`countries.${country.toLowerCase()}`) : '';
    return (_jsxs(Container, { children: [_jsx(Header, { title: t('menuGenerator.title'), breadcrumbItems: [
                    { id: 'brand-development', label: t('menuGenerator.breadcrumbItems.brandDevelopment') },
                    {
                        id: 'menu-generator',
                        label: t('menuGenerator.breadcrumbItems.menuGenerator'),
                    },
                ] }), isLoading && _jsx(Loader, { fullscreen: false }), !isLoading && !isCountryAllowed && (_jsx(TabContent, { children: _jsxs(Typography, { component: "subheadline", children: [countryName, " ", t('menuGenerator.notAllowed')] }) })), isCountryAllowed && (_jsx(TabsContainer, { children: _jsx(Tabs, { onTabClick: (tabId) => {
                        setActiveTab(tabId);
                    }, tabs: [
                        {
                            tabId: Tab.MenuGenerator,
                            tabName: t('menuGenerator.tabs.generated'),
                            isActive: activeTab === Tab.MenuGenerator,
                            content: (_jsx(TabContent, { children: _jsx(MenuGeneratorTable, {}) })),
                        },
                        {
                            tabId: Tab.Top10,
                            tabName: `${t('menuGenerator.tabs.top10')} ${countryName}`,
                            isActive: activeTab === Tab.Top10,
                            content: (_jsx(TabContent, { children: _jsx(Top10Table, { country: country }) })),
                        },
                    ] }) }))] }));
};
